<template>
  <div class="table-wrapper">
    <div class="container-fluid">
      <h6 class="mb-4">Job History</h6>
      <b-form @submit.prevent inline>
        <label class="sr-only" for="quoteStatus">Status</label>
           <div class="position-relative f-b">
                <i class="fas fa-search search-icon"></i>
        <b-form-input
          class="mb-2 mb-sm-0"
          placeholder="Search"
          :style="{'margin-left':'auto'}"
          v-model="filterQuery"
          @change="filter(1)"
        ></b-form-input>
           </div>
      </b-form>
      <br>
      <b-table
        :busy="this.$root.loading"
        :items="tableItems"
        :fields="tableFields"
        sort-icon-left
        hover
        responsive
        striped
        show-empty
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle" :variant="'primary'"></b-spinner>
          </div>
        </template>
           <template v-slot:cell(status)="row">
            <span v-if="row.item.Status == 'over-due' && row.item.is_work_order == false" style="color:rgb(180 70 70);" >Overdue</span>
            <span v-if="row.item.Status == 'due' && row.item.is_work_order == false" style="color: #5bb85b;" >Due Soon</span>
            <span v-if="row.item.Status == 'pending-approval' && row.item.is_work_order == false" style="color: #4682b4;" >Pending Approval</span>
            <span v-if="row.item.Status == 'open' && row.item.is_work_order == false" style="color: #5bb85b;" >{{row.item.Status}}</span>
            <span v-if="row.item.Status == 'active' && row.item.is_work_order == false" style="color: #4682b4;" >{{row.item.Status}}</span>
            <span v-if="row.item.Status == 'completed' && row.item.is_work_order == false" style="color:rgb(207, 14, 201);" >{{row.item.Status}}</span>
            <span v-if="row.item.Status == 'completed' && row.item.is_work_order == true" style="color:rgb(14 207 198);" >Awarded</span>
        </template>
        <template v-slot:cell(action)="row">
          <router-link
            v-if="row.item.is_work_order"
            :to="{
              name: 'manager-workorder-view',
              params: { id: row.item['id'] },
            }"
            >View
          </router-link>
           <router-link
            v-if="!row.item.is_work_order"
            :to="{
              name: 'manager-quote-view',
              params: { id: row.item['id'] },
            }"
            >View
          </router-link>
        </template>
        <template #empty class="text-center">
            No Data Found
        </template>
      </b-table>

      <div class="datagrid-footer" v-if="lastPage > 1">
        <b-pagination
          pills
          align="right"
          :total-rows="total"
          v-model="currentPage"
          :page-count="lastPage"
          :per-page="perPage"
          :hide-goto-end-buttons="true"
        ></b-pagination>
      </div>
      <br>
      <br>
        <b-row>
          <b-col md="12" class="d-none d-lg-block" style="margin-top: 9rem; margin-bottom: 1rem;">
            <footer-component></footer-component>
          </b-col>
        </b-row>
    </div>
  </div>
  
</template>

<script>
import _ from "lodash";
import moment from "moment";
import FooterComponent from "../../../../includes/FooterComponent.vue";


export default {
    components: {
    FooterComponent,
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      perPage: 50,
      lastPage: 1,
      tableItems: [],
      tableFields: [
        { key: "Date", sortable: true },
        { key: "Job ID", sortable: true },
        { key: "StrataManager", sortable: true},
        { key: "Address", sortable: true },
        { key: "Status", sortable: true },
        { key: "Action", sortable: false },
      ],
      filterQuery: "",
      filterStatus: "all",
    };
  },
  mounted() {
    this.filter();
  },
  methods: {
    filter(page = 1) {
      axios
        .post("api/manager/contacts/contractor/getJobHistory", {
          page: page,
          filter_params: this.filterParams,
          filter_status: this.filterStatus,
          filter_query: this.filterQuery,
          sort_field: "id",
          sort_order: "desc",
          per_page: 20,
          load_strata_plan: true,
          contractor_id: this.$route.params.id
        })
        .then((response) => {
          this.currentPage = response.data.current_page;
          this.total = response.data.total;
          this.perPage = response.data.per_page;
          this.lastPage = response.data.last_page;
          
          this.tableItems = _.map(response.data.quotes, function (quote) {
            return {
              is_work_order: quote.is_work_order,
              'id': quote.id,
              Date: moment(quote.issue_date).format("D MMM YYYY"),
              "Job ID": quote.organization_id,
              StrataManager: quote.manager.first_name + ' ' +  quote.manager.last_name,
              Address: quote.strata_plan.address,
              Status: quote.status_parsed,
              Action: "",
            };
          });
        });
    },
  },
};
</script>
